// import ChangesMonitor from 'src/constrains/SalesChannelContent-Revamp/HomePageChangesMonitor';
import ContentGrid from '@/src/components/SalesChannelComponents/SalesChannelContentGrid';
import { get } from 'lodash';
import { use404 } from 'src/pages/SalesChannelContentEditor/SalesChannelEditor404Page-revamp/hooks/use404';
import Wrapper from 'src/constrains/SalesChannelContentWrapperRevamp';
import React from 'react';
import { Form } from '@/src/components/RcForm';
import Visible from '@/src/components/Modules-revamp/Visible';
import { EPreviewSize } from '@/src/types/common/SalesChannel';

import ContentSetting from './ContentSetting';
import ButtonSetting from './ButtonSetting';
import FeatureProduct from '../Components/FeatureProducts-revamp';

import ChangesMonitor from 'src/pages/SalesChannelContentEditor/Components/ChangeMonitor';

import { getI18nFromGeneral } from 'src/tools/tools';
import RouteBlock from 'src/constrains/RouterBlock/RouterBlock';
import { debounce } from 'lodash';
import { formButtonList } from '@/src/strategies/util';
import { isPrimaryLanguage } from '@/src/constrains/SalesChannelMultiLanguageSelect/slice';
import { useSelector } from 'react-redux';

const Page404 = () => {
  const {
    buttons,
    salesChannel,
    hasModified,
    onGoBack,
    pcForm,
    mobileForm,
    tabletForm,
    handleOnReset,
    handleOnCopy,
    handleOnSubmit,
    handleOnDiscard,
    setHasModified,
    loaded,
    handlePCFormValuesChange,
    data,
  } = use404();
  const isPrimary = useSelector(isPrimaryLanguage());
  const headerProps = {
    title: get(salesChannel, 'name'),
    description: get(data, 'salesChannelContent.versionName'),
    status: get(data, 'salesChannelContent.status'),
    hasModified,
    onSubmit: handleOnSubmit,
    onDiscard: handleOnDiscard,
    onGoBack,
  };

  const commonProps = {
    handleOnSectionReset: handleOnReset,
    handleOnSectionCopy: handleOnCopy,
  };
  return (
    <Wrapper headerProps={headerProps}>
      <ChangesMonitor
        loaded={loaded}
        setHasModified={setHasModified}
        pcForm={pcForm}
        tabletForm={tabletForm}
        mobileForm={mobileForm}
      />

      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18nFromGeneral('general.commonHeader.discard_text')}
        active={hasModified}
        title={getI18nFromGeneral('general.commonHeader.discard_header')}
        content={getI18nFromGeneral('general.commonHeader.discard_content')}
      />
      <ContentGrid
        configCols={[
          {
            child: (
              <Form
                form={pcForm}
                onFieldsChange={debounce(handlePCFormValuesChange, 200)}>
                <Visible alwaysVisible breakpoint={EPreviewSize.WIDE} />
                <ContentSetting
                  breakpoint={EPreviewSize.WIDE}
                  handleOnSectionReset={handleOnReset}
                  tabletForm={tabletForm}
                  mobileForm={mobileForm}
                />
                <ButtonSetting
                  breakpoint={EPreviewSize.WIDE}
                  options={formButtonList(buttons || [])}
                  handleOnSectionReset={handleOnReset}
                  tabletForm={tabletForm}
                  mobileForm={mobileForm}
                />
                {isPrimary && (
                  <FeatureProduct
                    breakpoint={EPreviewSize.WIDE}
                    handleOnSectionReset={handleOnReset}
                    tabletForm={tabletForm}
                    mobileForm={mobileForm}
                    hasResetDot
                  />
                )}
              </Form>
            ),
          },
          {
            child: (
              <Form form={tabletForm}>
                <Visible alwaysVisible breakpoint={EPreviewSize.TABLET} />
                <ContentSetting
                  breakpoint={EPreviewSize.TABLET}
                  {...commonProps}
                />
                <ButtonSetting
                  breakpoint={EPreviewSize.TABLET}
                  options={formButtonList(buttons || [])}
                  {...commonProps}
                />
                {isPrimary && (
                  <FeatureProduct
                    breakpoint={EPreviewSize.TABLET}
                    {...commonProps}
                  />
                )}
              </Form>
            ),
          },
          {
            child: (
              <Form form={mobileForm}>
                <Visible alwaysVisible breakpoint={EPreviewSize.MOBILE} />
                <ContentSetting
                  breakpoint={EPreviewSize.MOBILE}
                  {...commonProps}
                />
                <ButtonSetting
                  breakpoint={EPreviewSize.MOBILE}
                  options={formButtonList(buttons || [])}
                  {...commonProps}
                />
                {isPrimary && (
                  <FeatureProduct
                    breakpoint={EPreviewSize.MOBILE}
                    {...commonProps}
                  />
                )}
              </Form>
            ),
          },
        ]}
        mainCol={null}
      />
    </Wrapper>
  );
};
export default Page404;
